// assets
import { IconBrandChrome, IconHelp, IconUser } from '@tabler/icons';
import CribOutlinedIcon from '@mui/icons-material/CribOutlined';
import ViewListIcon from '@mui/icons-material/ViewList';
// constant
const icons = { IconBrandChrome, IconHelp, IconUser };

// ==============================|| USER PAGE & DOCUMENTATION MENU ITEMS ||============================== //

const order = {
    id: 'user-docs-roadmap8',
    type: 'group',
    children: [
        {
            id: 'manageBanners',
            title: 'Manage Banners',
            type: 'item',
            url: '/manage-banners',
            icon: ViewListIcon,
            breadcrumbs: false
        }
    ]
};

export default order;
